import { attr } from '@ember-data/model';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';

// This is the JSON representation for squareup.inventory.v3.CatalogObject proto.
// Same as items.merchant.CatalogObject, but can be marshalled to JSON.
export default EmberDataBaseFragment.extend({
  token: attr('string'),
  type: attr('string'),
  attribute: fragmentArray('squareup/inventory/v3/catalog-object-attribute'),
  version: attr('number'),
  cogsId: attr('string'),
  getAttrStringValueByDefToken(token) {
    const attribute = this.attribute || [];
    let value = null;
    attribute.forEach(attr => {
      if (attr.get('definitionToken') === token) {
        value = attr.get('stringValue');
      }
    });
    return value;
  },
  getAttrIntValueByDefToken(token) {
    const attribute = this.attribute || [];
    let value = null;
    attribute.forEach(attr => {
      if (attr.get('definitionToken') === token) {
        value = attr.get('intValue');
      }
    });
    return value;
  }
}).reopenClass({
  _modelNameForMigration: 'squareup/inventory/v3/catalog-object'
});